import { useEffect } from 'react';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';

import type { IQ11LoginResponse } from '../useApi/usePostIQ11Login';

const useIQ11LoginDialogue = (response?: IQ11LoginResponse): { showDialogue: () => void } => {
  const errorMessage: string = response?.errorMessage || '';

  const { provideProps, showDialogue } = useConfirmationDialogue();

  const messageMap: { [key: string]: string } = {
    'Required parameter(s) missing: EmailAddress ': 'Please provide an email address.',
    'Required parameter(s) missing: Password': 'Please provide a password.',
    'Required parameter(s) missing: EmailAddress, Password': 'Please provide a email address and password.',
    'Invalid EmailAddress!': 'An invalid emailAddress was provided.',
    'Invalid Password!': 'An invalid password was provided.',
  };

  useEffect(() => {
    const handlers = {
      errorMessage: () => {
        provideProps({
          title: 'Unsuccessful login! There is a problem with your login credentials.',
          subTitle: messageMap[errorMessage] || errorMessage,
          status: 'error',
          confirm: {
            label: 'Stay here and try again',
            action: () => {},
          },
        });
      },
    };

    if (errorMessage) return handlers.errorMessage();

    return handlers.errorMessage();
  }, [errorMessage]);

  return { showDialogue };
};

export default useIQ11LoginDialogue;
